const state = {
    shippingPolicyList: [
        {
            id: '65465',
            title: 'Shipping policy rule 1',
            byPriceDelivery: {
                'between': [500, 3500]
            },
            byValueProduct: {
                'less_than': [150]
            },
            byParcelValue: {
                'less_than': [150]
            },
            couriers: [],
            deliveryOptions: ['delivery_domestic'],
            insuranceAlways: true,
            insuranceDetail: {
                couriers: [],
                deliveryType: [],
                deliveryServiceType: []
            },
            service: 'fastest',
            products: []
        },
        {
            id: '6546asd5',
            title: 'Shipping policy rule 2',
            byPriceDelivery: {
                'between': [350, 2587]
            },
            byValueProduct: {
                'less_than': [250]
            },
            byParcelValue: {
                'less_than': [150]
            },
            couriers: [],
            deliveryOptions: ['delivery_domestic', 'delivery_eu'],
            insuranceAlways: true,
            insuranceDetail: {
                couriers: [],
                deliveryType: [],
                deliveryServiceType: []
            },
            service: 'cheapest',
            products: []
        },
        {
            id: 'asdfasd654',
            title: 'Shipping policy rule 3',
            byPriceDelivery: {
                'between': [20, 500]
            },
            byValueProduct: {
                'equal_to': [350]
            },
            byParcelValue: {
                'less_than': [150]
            },
            couriers: [],
            deliveryOptions: ['delivery_domestic'],
            insuranceAlways: true,
            insuranceDetail: {
                couriers: [],
                deliveryType: [],
                deliveryServiceType: []
            },
            service: 'fastest',
            products: []
        }
    ]
}

const getters = {
    shippingPolicyList(state) {
        return state.shippingPolicyList
    }
}

const mutations = {
    ADD_RULE(state, payload) {
        state.shippingPolicyList.push(payload)
    },
    SET_PRODUCTS(state, payload) {
        state.shippingPolicyList.filter(item => item.id === payload.id)[0].products.push(...payload.products)
    },
    EDIT_RULE(state, payload) {
        Object.assign(state.shippingPolicyList.filter(item => item.id === payload.id)[0], payload)
    },
    DELETE_RULE(state, index) {
        state.shippingPolicyList.splice(index, 1)
    }
}

const actions = {}

export default {
    mutations,
    actions,
    getters,
    state
}



// WEBPACK FOOTER //
// ./src/store/modules/shipping-policy-state.js